













import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import OpenBrokerageSearch from "@/shared/components/investments/drivewealth/OpenBrokerageSearch.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { DrivewealthAccountSummary, DrivewealthAccountManagementType } from "@/shared/types";
import _ from "lodash";

@Component({
  components: {
    AccountTypeSubheader,
    OpenBrokerageSearch
  }
})
export default class DrivewealthChoiceOptionFundsList extends Vue {
  @Prop() accountId: number;

  drivewealthStore = useDrivewealthStore();

  mounted (): void {
    this.drivewealthStore.loadAccountSummariesV2({});
  }

  get openBrokerageAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
        x => x.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage);

    return account;
  }

  get openBrokerageAccountId (): string|number {
    return this.openBrokerageAccount !== undefined ?
        this.openBrokerageAccount.drivewealthAccountId : 0;
  }
}
